exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".labeled-string{display:flex;flex-flow:row wrap;padding-bottom:5px}.labeled-string .data-label{color:#aaa;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/labeled-string/index.scss
// module id = 5267
// module chunks = 0